import { useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Modal } from 'antd';
import UserMenu from './UserMenu';

import { useSelector, useDispatch } from 'react-redux';
import { updateEvent } from '../redux/slices/eventSlice';
import logo from '../assets/login-logo.svg';
import EventStatus from './EventStatus';
import ReviewEventInWx from './ReviewEventInWx';
import VersionUpdateButton from './VersionUpdateButton';

import request from '@/request';

export default function Navigation() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const { event } = useSelector((state) => state.event);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const location = useLocation();

  // const isActive = (path) => location.pathname === path;

  // const navLinks = [
  //   { path: '/booth', label: '平台' },
  //   { path: '/', label: '赛事' },
  //   { path: '/referee', label: '裁判' },
  //   { path: '/organization', label: '机构' },
  // ];

  const submitReview = useCallback(async () => {
    setLoading(true);
    try {
      await request.put(`/events/applyReview/${event.id}`);
      const data = await request.get(`/events/info/${event.id}`);
      dispatch(updateEvent(data));
    } finally {
      setLoading(false);
      setIsModalOpen(false);
    }
  }, [dispatch, event.id]);

  return (
    <nav className="w-screen h-[60px] bg-white border-b border-slate-200 sticky top-0 z-50 flex items-center">
      {/* Full-width navbar */}
      <div className="w-full px-4 py-2 flex items-center justify-between relative">
        {/* Logo Section - Left */}
        <div className="flex items-center">
          <Link
            to="/"
            className="flex items-center gap-2 hover:opacity-80 transition-opacity duration-200 flex-shrink-0"
          >
            <img src={logo} alt="Logo" className="h-[38px] w-auto object-contain" />
            <span
              className={`text-stone-900 ${location.pathname.startsWith('/event') ? 'border-r border-stone-300' : ''} text-2xl/6 mr-6 pr-6 font-semibold`}
            >
              跑酷及障碍跑赛事管理系统
            </span>
          </Link>

          {location.pathname.startsWith('/event') && event.id && (
            <div className="flex items-center gap-4">
              <h1 className="text-xl text-stone-800 truncate max-w-120">
                {event.name}
              </h1>
              <EventStatus text={event?.showStatus} status={event?.status} />
              {event?.items.length > 0 && event?.status <= 0 && (
                <button
                  disabled={event?.items?.length === 0 || loading}
                  className={`inline-flex items-center gap-2 px-6 py-1.5 font-semibold rounded-lg transition-all duration-200 ${
                    event?.items?.length === 0 || loading
                      ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
                      : 'bg-blue-600 text-white hover:bg-blue-700 hover:shadow-lg hover:shadow-blue-600/25 cursor-pointer'
                  }`}
                  title="提交审核"
                  onClick={() => setIsModalOpen(true)}
                >
                  {loading ? (
                    <svg
                      className="animate-spin h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  ) : (
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  )}
                  <span className="text-xl">发布</span>
                </button>
              )}

              <ReviewEventInWx event={event} />
            </div>
          )}

          <Modal
            title={'发布' + event.name}
            closable={{ 'aria-label': 'Custom Close Button' }}
            open={isModalOpen}
            onOk={submitReview}
            onCancel={() => setIsModalOpen(false)}
            okText="确定"
            cancelText="取消"
          >
            <p>
              发布后我们需要几分钟确认您的信息，随后即可在小程序端正式发布。
            </p>
          </Modal>
        </div>

        {/* Navigation Links - Right */}
        {/* <div className="flex items-center gap-1 sm:gap-1 ml-auto mr-2">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-3 sm:px-4 py-2 text-base font-medium transition-colors duration-150 cursor-pointer relative ${
                isActive(link.path)
                  ? 'text-slate-900'
                  : 'text-slate-400 hover:text-slate-900'
              }`}
            >
              {link.label}
              {isActive(link.path) && (
                <div className="absolute bottom-1 left-1/2 -translate-x-1/2 w-10 h-0.5 bg-blue-500 rounded"></div>
              )}
            </Link>
          ))}
        </div> */}

        {/* Right Section - Icons and User Menu */}
        <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
          <VersionUpdateButton />

          {/* QR Button (hover preview) - left of notifications */}
          <div className="relative group">
            <button
              type="button"
              aria-label="主办方首页"
              className="relative inline-flex items-center justify-center p-2 rounded-md hover:bg-slate-100"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-slate-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
                aria-hidden="true"
              >
                <rect x="3" y="3" width="5" height="5" rx="1" strokeWidth={2} />
                <rect
                  x="16"
                  y="3"
                  width="5"
                  height="5"
                  rx="1"
                  strokeWidth={2}
                />
                <rect
                  x="3"
                  y="16"
                  width="5"
                  height="5"
                  rx="1"
                  strokeWidth={2}
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M14 7h1v1"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M11 10h1v1"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M14 13h1v1"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17 16h1v1"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10 17h1v1"
                />
              </svg>
            </button>

            {/* Hover QR preview (use Login page animation classes) */}
            <div className="absolute right-0 -mt-1 w-40 rounded-md shadow-lg bg-white p-2 opacity-0 scale-95 transition-all duration-200 group-hover:opacity-100 group-hover:scale-100 pointer-events-none z-50">
              <img
                src={user?.org?.wxacode}
                alt="主办方首页"
                className="w-full h-full object-cover rounded-sm"
              />
              <span className="text-sm mt-2">主办方首页</span>
            </div>
          </div>

          {/* Notifications (hover preview) */}
          <div className="relative group">
            <button
              type="button"
              aria-label="查看通知"
              className="relative inline-flex items-center justify-center p-2 rounded-md hover:bg-slate-100"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 text-slate-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118.6 14.6V11a6.002 6.002 0 00-4-5.659V4a2 2 0 10-4 0v1.341C7.67 6.165 6 8.388 6 11v3.6c0 .518-.197 1.017-.545 1.395L4 17h11z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13.73 21a2 2 0 01-3.46 0"
                />
              </svg>
              <span className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-semibold leading-none text-white bg-red-500 rounded-full">
                3
              </span>
            </button>

            {/* Hover dropdown preview (reduced gap so cursor can move from button to menu)
              Use opacity+scale enter/exit animation (same as login QR preview) */}
            <div className="absolute right-0 -mt-1 w-80 bg-white border border-slate-200 rounded-md shadow-lg z-50 p-3 opacity-0 scale-95 transition-all duration-200 group-hover:opacity-100 group-hover:scale-100 pointer-events-none group-hover:pointer-events-auto">
              <div className="flex items-center justify-between mb-2">
                <p className="text-sm font-medium text-slate-900">最新通知</p>
                <button className="text-xs text-slate-400 hover:text-slate-600">
                  标记为已读
                </button>
              </div>
              <ul className="space-y-2 text-sm text-slate-600 max-h-60 overflow-auto">
                <li className="flex items-center gap-3 p-2 rounded-md hover:bg-slate-50 cursor-pointer">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-3">
                      <p className="text-sm font-medium text-slate-900 truncate">
                        新的报名已提交
                      </p>
                      <span className="text-xs text-slate-400 flex-shrink-0">
                        2 小时前
                      </span>
                    </div>
                    <p className="text-xs text-slate-500 truncate text-left">
                      来自：张三 - 男子组 100m 报名
                    </p>
                  </div>
                </li>
                <li className="flex items-center gap-3 p-2 rounded-md hover:bg-slate-50 cursor-pointer">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-3">
                      <p className="text-sm font-medium text-slate-900 truncate">
                        裁判信息已更新
                      </p>
                      <span className="text-xs text-slate-400 flex-shrink-0">
                        昨天
                      </span>
                    </div>
                    <p className="text-xs text-slate-500 truncate text-left">
                      李老师 已上传执裁证书
                    </p>
                  </div>
                </li>
                <li className="flex items-center gap-3 p-2 rounded-md hover:bg-slate-50 cursor-pointer">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-3">
                      <p className="text-sm font-medium text-slate-900 truncate">
                        系统维护公告
                      </p>
                      <span className="text-xs text-slate-400 flex-shrink-0">
                        3 天前
                      </span>
                    </div>
                    <p className="text-xs text-slate-500 truncate text-left">
                      计划在周日凌晨 2:00 — 4:00 进行系统维护
                    </p>
                  </div>
                </li>
              </ul>
              <div className="mt-2 text-right">
                <a
                  href="/notifications"
                  className="text-indigo-600 hover:underline text-sm"
                >
                  查看全部
                </a>
              </div>
            </div>
          </div>

          {/* User Menu */}
          <UserMenu />
        </div>
      </div>
    </nav>
  );
}
